import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { take, tap, concatMap } from 'rxjs/operators';

import protocolProfileToProductTypeMapping from '../../../shared/mappings/protocol-profile-to-product-type.mapping';
import { AnalyticsService } from '../../../shared/services/analytics.service';
import { StoreService } from '../../../shared/services/store.service';
import { AppState } from '../../../shared/store/app-state';
import { BoxActions } from '../actions/box.actions';
import { SiteDetailPageActions } from '../actions/site-detail-page.actions';
import { getRawDevice } from '../selectors/device-detail';

@Injectable({ providedIn: 'root' })
export class SiteDetailAnalyticsEffects {
    private readonly actions$ = inject(Actions);
    private readonly storeService = inject<StoreService<AppState>>(StoreService);
    private readonly analyticsService = inject(AnalyticsService);

    logDeviceEditionRequested$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(SiteDetailPageActions.deviceUpdateRequested),
                concatMap((updateRequest) =>
                    this.storeService.select(getRawDevice(updateRequest.deviceId)).pipe(
                        take(1),
                        tap((device) => {
                            const productType = protocolProfileToProductTypeMapping[device.protocol_profile];
                            this.analyticsService.editDeviceParameter(
                                productType,
                                updateRequest.property.id,
                                'Installation',
                            );
                        }),
                    ),
                ),
            ),
        { dispatch: false },
    );

    logRebootBoxRequested$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(BoxActions.boxRebootRequested),
                tap(() => this.analyticsService.rebootBox()),
            ),
        { dispatch: false },
    );
}
